<template>
  <div>
    <customer-search-box
      :info-text="i18n.t('/KlantZoekenModal/LokaalZoekenInfo')"
      @on-search="onSearch"
    />

    <loader v-if="loading" type="alert" />
    <alert v-if="errorText" :text="errorText" />
  </div>
</template>

<script>
import { minLength, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import CustomerSearchBox from '@/components/generic/presentational/molecules/customerSearch/CustomerSearchBox.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import CustomerSearchHelper from '@/helpers/CustomerSearchHelper'
import { mapState } from 'vuex'

export default {
  components: {
    Loader,
    CustomerSearchBox,
    Alert,
  },
  emits: ['hasSearchedDealerCustomers', 'hasSearchedByLicencePlate'],
  setup() {
    return { v$: useVuelidate() }
  },
  validations: {
    userInput: {
      required,
      minLength: minLength(3),
    },
  },
  data() {
    return {
      loading: false,
      userInput: '',
      errorText: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
  },
  methods: {
    async onSearch(query) {
      this.loading = true
      this.search(query)
    },
    search(query) {
      this.errorText = ''
      this.userInput = query

      if (this.validate()) {
        // Filter license plate
        const filteredLicensePlate = CustomerSearchHelper.filterLicensePlate(query)
        let searchEndpoint = 'searchDealerCustomers'
        if (this.dealerSettings.autolineKeyloopEnabled && filteredLicensePlate) {
          query = filteredLicensePlate
          searchEndpoint = 'searchRelationsByLicensePlate'
        }
        if (CustomerSearchHelper.filterZipcode(query)) {
          query = query.replace(' ', '')
        }

        let searchedByLicensePlate =
          this.dealerSettings.autolineKeyloopEnabled && filteredLicensePlate

        this.$emit('hasSearchedByLicencePlate', searchedByLicensePlate)

        this.$store
          .dispatch(`customer/${searchEndpoint}`, query)
          .then(async () => {
            if (searchedByLicensePlate) {
              await this.$store.dispatch('customer/getCarInfo', filteredLicensePlate)
            }
          })
          .catch(() => {
            this.errorText = this.i18n.t('/KlantZoekenModal/AutolineError')
          })
          .finally(() => {
            this.loading = false
            this.$emit('hasSearchedDealerCustomers')
          })
      } else {
        this.loading = false
        this.errorText = this.i18n.t('/KlantZoekenModal/LokaalZoekenError')
      }
    },
    validate() {
      this.v$.$touch()
      return !this.v$.$invalid
    },
  },
}
</script>
